import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { flexColumn } from '../../../../common/styles/flex';

interface StylesObject {
  videoContainerStyle: { [key: string]: any };
  videoStyle: { [key: string]: any };
  thumbnailStyle: { [key: string]: any };
  blurThumbnailStyle: { [key: string]: any };
  playBlurIconStyle: { [key: string]: any };
  durationStyle: { [key: string]: any };
  titleStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const titleColor = SITE_VARIABLES.COLORS.WHITE;

const videoContainer = {
  ...flexColumn,
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK_80_OPACITY,
  width: '91px',
  height: '93px',
  endState: {
    width: '165px',
    height: '128px',
  },
};

const video = {
  position: 'relative',
  cursor: 'pointer',
  width: '83px',
  height: '42px',
  margin: '4px 4px 3px 4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'auto',
  endState: {
    width: '153px',
    height: '86px',
    margin: '6px 6px 3px 6px',
  },
};

const thumbnail = {
  width: '100%',
  height: '100%',
};

const blurThumbnail = {
  position: 'absolute',
  bottom: '0',
  width: '100%',
  backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.71))',
  height: '18px',
  endState: {
    height: '56px',
  },
};

const playBlurIcon = {
  display: 'flex',
  position: 'absolute',
  width: '16px',
  height: '16px',
  endState: {
    width: '24px',
    height: '24px',
  },
};

const duration = {
  position: 'absolute',
  bottom: '2px',
  right: '2px',
  fontFamily: titleFontFamily,
  fontWeight: '400',
  fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_TINY,
  color: titleColor,
  endState: {
    bottom: '3px',
    right: '4px',
  },
};

const title = {
  fontFamily: titleFontFamily,
  fontWeight: '300',
  fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
  WebkitLineClamp: '2',
  overflow: 'hidden',
  color: titleColor,
  margin: '0px 4px 4px 4px',
  endState: {
    margin: '0px 6px',
    fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_SMALL,
  },
};

export const getMiddleScreenVideoStyleObject = (isEndState: boolean): StylesObject => ({
  videoContainerStyle: [
    videoContainer,
    isEndState && videoContainer.endState,
  ],
  videoStyle: [
    video,
    isEndState && video.endState,
  ],
  thumbnailStyle: {
    ...thumbnail,
  },
  blurThumbnailStyle: [
    blurThumbnail,
    isEndState && blurThumbnail.endState,
  ],
  playBlurIconStyle: [
    playBlurIcon,
    isEndState && playBlurIcon.endState,
  ],
  durationStyle: [
    duration,
    isEndState && duration.endState,
  ],
  titleStyle: [
    title,
    isEndState && title.endState,
  ],
});
